<template>
  <div class="p-fluid">
    <template v-if="!disabled">
      <client-only placeholder="Loading editor...">
        <PrimeEditor
          v-model="currentValue"
          @change="changeEventHandler($event)"
          @blur="blurEventHandler($event)"
          @input="inputEventHandler($event)"
          v-bind="$attrs"
          :disabled="loading || disabled"
        ></PrimeEditor>
      </client-only>
    </template>
    <template v-else>
      <!--
        Rich text is authored by users, so it is rendered through the allow-list
        sanitiser. That needs a DOM, hence client-only, as above.
      -->
      <client-only>
        <div v-html="sanitizeHtml(currentValue, 'richText')"></div>
      </client-only>
    </template>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  disabled: boolean;
}>();

const emits = defineEmits<{
  change: [event: any];
  blur: [event: any];
  input: [event: any];
}>();

const currentValue = defineModel<any>("value");
const loading: Ref<boolean> = ref(false);

onMounted(() => {
  loading.value = true;
});

function changeEventHandler($event: any) {
  emits("change", { ...$event, ...{ value: currentValue.value } });
}
function blurEventHandler($event: any) {
  emits("blur", { ...$event, ...{ value: currentValue.value } });
}
function inputEventHandler($event: any) {
  emits("input", { ...$event, ...{ value: currentValue.value } });
}
</script>

<style lang="scss" scoped></style>
